/** @format */
import { Box } from '@mui/material';
import MultiSelectBox from '../../MultiSelect/MultiSelect';
import { produce } from 'immer';

export default function Parameter({ filters, setFilters }) {
  const { parameters = [] } = filters;

  const handleChange = (index) => (event, value, reason) => {
    setFilters(
      produce((draft) => {
        draft.parameters[index].selected =
          typeof value === 'string' ? value.split(',') : value;
      })
    );
  };

  const selectAllHandler = (index) => (isSelectAllChecked) => {
    setFilters(
      produce((draft) => {
        if (isSelectAllChecked) {
          draft.parameters[index].selected = draft.parameters[index].total;
        } else {
          draft.parameters[index].selected = [];
        }
      })
    );
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}
    >
      {parameters.map((parameter, idx) => (
        <MultiSelectBox
          key={parameter.name || idx}
          placeholder={
            parameter.placeholder || parameter.name || `Parameter ${idx + 1}`
          }
          variant="outlined"
          width="100%"
          defaultAllSelected={true}
          selectAllHandler={selectAllHandler(idx)}
          selectedList={parameter.selected}
          selectList={parameter.total}
          handleChange={handleChange(idx)}
          handleClose={() => {}}
        />
      ))}
    </Box>
  );
}
